import { TeamMemberType } from "@/types/global";
import Image from "next/image";
import Link from "next/link";

interface Props {
    data: TeamMemberType;
}

const TeamAreaCard = ({ data }: Props) => {
    console.log('data', data);
    return (
        <>
            <div className="desilo-team-box">
                <figure className="team-thumb">
                    {/* <Image
                        height={400}
                        width={400}
                        sizes="100vw"
                        src={data.image}
                        alt="team"
                        className="w-100"
                    /> */}
                    <Image
                        height={400}
                        width={400}
                        sizes="100vw"
                        src={data.image}
                        alt="team"
                        className="w-100 h-100"
                    />
                    <ul className="custom-ul">
                        {/* <li>
                            <Link href={data.socialLinks.facebook}>
                                <i className="fa-brands fa-facebook-f" />
                            </Link>
                        </li>
                        <li>
                            <Link href={data.socialLinks.twitter}>
                                <i className="fa-brands fa-x-twitter" />
                            </Link>
                        </li>
                        <li>
                            <Link href={data.socialLinks.instagram}>
                                <i className="fa-brands fa-instagram" />
                            </Link>
                        </li> */}
                        <li>
                            <Link target="_blank" href={data.socialLinks.linkedin}>
                                <i className="fa-brands fa-linkedin-in" />
                            </Link>
                        </li>
                    </ul>
                </figure>
                <div className="team-content">
                    <h3 className="team-data-name">
                        {data.name}
                    </h3>
                    {/* <span className="team-data-position">{data.position}</span> */}
                    <span className="team-data-position d-inline-block pt-3 ">{data.description}</span>
                </div>
            </div>
        </>
    );
};

export default TeamAreaCard;
